<template>
	<div class="chatrsinfo">
		<div class="chatrsinfo_title">
			<h3 class="chatrsinfo_title_left">{{chartMap.chartTitle}}：</h3>
			<el-link class="chatrsinfo_title_right" type="primary" @click="chartsInfoBack">返回</el-link>
			<div style="clear: both;"></div>
		</div>
		<div class="container">
			<div class="item-left"> {{chartMap.chartTotalTilte}}:{{chartMap.chartTotalNum}}</div>
			<div class="item-right">{{chartMap.chartNewTilte}}:{{chartMap.chartNewNum}}</div>
		</div>
		<div>
			<div style="text-align:left;">

				選擇時間:<input ref="seletdateid" v-model="seletdate" type="month" @change="changeSelect" />
			</div>
			<div ref="chatinfo" style="display: block;margin: 0;width: 100%;height: 300px;padding: 5px">
				<div ref="chat1" style="height: 100%;">
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getCurrentInstance,
		onBeforeUnmount,
		onMounted,
		watch,
		ref,
		toRef,
		provide
	} from 'vue'
	import * as echarts from 'echarts';
	import util from '@/util/util'
	import {
		useUserinfo
	} from "@/stores/userinfo";
	import eshopopeeApi from "@/request/eshopopeeApi";
	import reportApi from "@/request/reportApi";

	const emits = defineEmits(['@clickChartInfobackBtn'])

	const userInfoRef = toRef(useUserinfo())
	const {
		proxy
	} = getCurrentInstance()


	const props = defineProps(['chartMap'])
	var option11
	var myChart11

	const listDates = ref([])

	const listDatas = ref([])

	const componentWidth = ref(375)

	const seletdate = ref(util.formatDate(new Date(), 'yyyy-MM'));
	const seletdate2 = ref(util.formatDate(new Date(), 'yyyy/MM'));

	function changeSelect() {
		if (seletdate.value != null) {
			seletdate2.value = seletdate.value.substr(0, 4) + "/" + seletdate.value.substr(-2, 2)
			getDayCount()
		}
	}

	function chartsInfoBack(obj) {
		emits("clickChartInfobackBtn")
	}

	function getDayCount() {
		switch (props.chartMap.type) {
			case 1:
			getVisitDataByDate()
				break;
			case 2:
				getUserDayCount();
				break
			case 3:
			 getBODayCount();
				break;
			case 4:
				break;

		}

	}
	
	function getUserDayCount() {
		const request = reportApi.queryUserDataByDate
		const params = request.getParams()
		params.CompanyCode = userInfoRef.value.companycode
		params.month = seletdate2.value
		request.send(params, (res) => {
			listDatas.value = []
			var num = 0
			
			console.log(listDatas.value.length)
			for (var i = 0; i < res.detail.length; i++) {
				listDatas.value.push(res.detail[i].num)
				num += res.detail[i].num
			}
			
			console.log(listDatas.value.length)
			props.chartMap.chartNewNum = num
			
			changeChart()
		})
	}

	function getBODayCount() {//郵件發送數（新增用戶）
		const request = eshopopeeApi.getBODayCount
		const params = request.getParams()
		params.CompanyCode = userInfoRef.value.acccompanycode
		params.month = seletdate2.value
		request.send(params, (res) => {
			listDatas.value = []
			var num = 0
			for (var i = 0; i < res.length; i++) {
				listDatas.value.push(res[i].boNum)
				num += Number(res[i].boNum)
			}
			props.chartMap.chartNewNum = num
			changeChart()
		})
	}
	
	function getVisitDataByDate() {//查詢瀏覽數
		const request = reportApi.queryVisitDataByDate
		const params = request.getParams()
		params.CompanyCode = userInfoRef.value.companycode
		params.month = seletdate2.value
		request.send(params, (res) => {
			listDatas.value = []
			var num = 0
			
			console.log(listDatas.value.length)
			for (var i = 0; i < res.detail.length; i++) {
				listDatas.value.push(res.detail[i].num)
				num += res.detail[i].num
			}
			
			console.log(listDatas.value.length)
			props.chartMap.chartNewNum = num
			
			changeChart()
		})
	}

	function changeChart() {//訂單數
		var listNum = Number(getLastDayOfMonth(seletdate.value.substr(0, 4), seletdate.value.substr(-2, 2)))
		listDates.value = []
		for (var i = 0; i < listNum; i++) {
			listDates.value.push((i + 1) + "日")
		}
		option11.xAxis.data = listDates.value
		option11.series[0].data = listDatas.value

		myChart11.setOption(option11);
	}




	function initData() {
		var listNum = Number(getLastDayOfMonth(seletdate.value.substr(0, 4), seletdate.value.substr(-2, 2)))
		listDates.value = []
		for (var i = 0; i < listNum; i++) {
			listDates.value.push((i + 1) + "日")
		}
		listDatas.value = []
		myChart11 = echarts.init(proxy.$refs.chat1);
		window.addEventListener('resize', myChart11.resize);
		option11 = drawChart()
		myChart11.setOption(option11);

	}


	onMounted(() => {
		// componentWidth.value = proxy.$refs.chatinfo.offsetWidth
		initData()
		getDayCount() 


	})

	function getLastDayOfMonth(year, month) {
		// 创建一个Date对象，设置年份和月份
		var lastDay = new Date(year, month, 0);
		return lastDay.getDate(); // 获取最后一天的日期
	}


	/*繪製圖*/
	function drawChart() {
		let option = {
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: listDates.value
			},
			yAxis: {
				type: 'value'
			},
			series: [{
				label: {
					show: true,
					position: 'top'
				},
				data: listDatas.value,
				type: 'line',
				// type: 'bar',
			}]
		};
		return option;
	}
</script>


<style scoped>
	.container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.item-left {
		margin: 5px;
		/* 可选，用于添加两个盒子之间的间隔 */
		width: 50%;
		height: 60px;
		text-align: left;
	}

	.item-right {
		margin: 5px;
		/* 可选，用于添加两个盒子之间的间隔 */
		width: 50%;
		height: 60px;
		text-align: left;
	}

	.chatrsinfo_title {
		height: 70px;
	}

	.chatrsinfo_title_left {
		float: left;
	}

	.chatrsinfo_title_right {
		float: right;
		margin-top: 20px;
	}

	@media screen and (max-width: 520px) {

		/*小屏幕*/
		.chatrsinfo {
			margin: 0px 5px 0px 5px;
			padding: 8px 8px 8px 8px;
			/* border-radius: 10px;
			border: 1px solid; */
			/* 设置边框宽度和样式 */
			/* border-color: #aaaaaa; */
			/* 设置边框颜色为红色 */
		}
	}

	@media screen and (min-width: 520px) {

		.chatrsinfo {
			margin: 10px 50px 10px 50px;
			padding: 8px 8px 30px 8px;
			/* border-radius: 10px;
			border: 1px solid; */
			/* 设置边框宽度和样式 */
			/* border-color: #aaaaaa; */
			/* 设置边框颜色为红色 */
		}
	}
</style>